/****** includes ******/
//require('./bootstrap');

import $ from 'jquery';

window.jQuery = $;

require('@fancyapps/fancybox/dist/jquery.fancybox');

import 'jquery-ui/ui/widgets/tooltip.js';


/****** breakpoints ******/
var breakpoint_mobile = 325;
var breakpoint_phablet = 576;
var breakpoint_tablet = 768;
var breakpoint_tablethor = 1024;
var breakpoint_laptop = 1200;
var breakpoint_desktop = 1360;
var breakpoint_mediumdesktop = 1500;
var breakpoint_largedesktop = 1800;

/****** init. doc ******/
$('document').ready(setup);


/****** setup ******/
function setup() {
    //console.log('setup');

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    initBlockVideo();
    initTips();
    initPageHome();
    initPageTunnel();
    initAnchors();
}

/**
 * Block Video
 */
function initBlockVideo() {
    $('.block-video--link').fancybox();
}

/**
 * Init Tips
 */
function initTips() {
    if ($(window).outerWidth() < breakpoint_phablet) {
        $('.tooltip').tooltip({
            position: {my: "center bottom-25", at: "right bottom"},
            classes: {
                "ui-tooltip": "tooltip-box"
            },
            show: null,
            close: function (event, ui) {
                ui.tooltip.hover(
                    function () {
                        $(this).stop(true).fadeTo(400, 1);
                    },
                    function () {
                        $(this).fadeOut("400", function () {
                            $(this).remove();
                        })
                    }
                );
            }
        });

        $('body').on('click touch', '.tooltip', function (e) {
            $(this).tooltip("open");
        });
    } else {
        $('.tooltip').tooltip({
            position: {my: "left+15 center", at: "right center"},
            classes: {
                "ui-tooltip": "tooltip-box"
            },
            content: function () {
                return $(this).prop('title');
            },
            show: null,
            close: function (event, ui) {
                ui.tooltip.hover(
                    function () {
                        $(this).stop(true).fadeTo(400, 1);
                    },
                    function () {
                        $(this).fadeOut("400", function () {
                            $(this).remove();
                        })
                    }
                );
            }
        });
    }
}

/**
 * Init Home
 */
function initPageHome() {
    ///// home
    if ($('.block-sale').length) {
        $('body').on('click', '.block-sale .btn-submit', function (e) {
            submitFormG1();
        });
        $('body').on('submit', '.form-g1', function (e) {
            submitFormG1();
            return false;
        });
    }
    if ($('.block-construct').length) {
        $('body').on('click', '.block-construct .btn-submit', function (e) {
            submitFormG2();
        });
        $('body').on('submit', '.form-g2', function (e) {
            submitFormG2();
            return false;
        });
    }
}

function submitFormG1() {
    var zipCode = $('#form-zipcode-g1').val().trim();
    if (zipCode.length != 5 || (isNaN(zipCode))) {
        $('#form-alert-zipcode-g1').text("Le format du code postal n’est pas correct").removeClass('is-empty');
        $('#form-zipcode-g1').focus();
    } else {
        document.location.href = "order?zipcode=" + encodeURIComponent(zipCode);
    }
}

function submitFormG2() {
    var zipCode = $('#form-zipcode-g2').val().trim();
    if (zipCode.length != 5 || (isNaN(zipCode))) {
        $('#form-alert-zipcode-g2').text("Le format du code postal n’est pas correct").removeClass('is-empty');
        $('#form-zipcode-g2').focus();
    } else {
        window.open("https://www.ginger-cebtp.com/nos-agences?zipcode=" + encodeURIComponent(zipCode));
    }
}

/**
 * Init Tunnel
 */
function initPageTunnel() {
    // commun
    if ($('.tunnel-wrapper').length) {
        // bloc sticky
        if ($('.push-contact').length) {
            refreshPushContact();
            $(window).on('scroll', function () {
                refreshPushContact();
            });
        }

        // inputs files
        $('body').on('change', 'input[type=file]', function (e) {
            let nameFile = $(this).val().split(/(\\|\/)/g).pop();
            let idField = $(this).prop('id');
            let btnReset = $('.reset-form-file[data-id-file=' + idField + ']');

            $(this).next('.name-file').addClass('is-selected').text(nameFile);

            if (nameFile.length > 0) {
                btnReset.addClass('show');
            }
            else {
                btnReset.click();
            }
        });
        $('body').on('click', '.reset-form-file', function (e) {
            e.preventDefault();
            let idFormFile = $(this).data('id-file');
            if (idFormFile !== undefined) {
                $('#' + idFormFile)
                    .val('')
                    .next('.name-file')
                    .removeClass('is-selected')
                    .text('');
                $(this).removeClass('show');
            }
        });

        // format fields errors
        formatFieldsErrors();
    }

    ///// étape 1
    if ($('.tunnel-wrapper.step1').length) {
        //$('$tunnel-content').

        $('#step1-more-informations').addClass('is-hide');

        // zip code
        validateZipcode($('#zipcode'));
        $('body').on('input', '#zipcode', function (e) {
            validateZipcode($(this));
        });
        $('body').on('blur', '#zipcode', function (e) {
            var zipCode = $(this).val().trim();
            if (zipCode.length >= 0 && (zipCode.length != 5 || (isNaN(zipCode)))) {
                $(this).focus();
                blockForm('#zipcode', $('#form-alert-zipcode'), "Le format du code postal n’est pas correct");
                // désactivation push contact
                $('#step1-more-informations').removeClass('is-show').addClass('is-hide');
                $('.push-contact').addClass('hidden');
            }
        });

        if ($('.tunnel-content .form-errors').length === 0) {
            $('#form-item-network-presence').addClass('is-hide');
            $('#form-item-desired-deadline').addClass('is-hide');
            $('#form-item-land-accessibility').addClass('is-hide');
            $('#form-item-network-presence').addClass('is-hide');
            $('#submit-step-1').parent().removeClass('is-show').addClass('is-hide');
            $('#submit-step-1').prop('disabled', true);
        } else {
            $('#submit-step-1').parent().removeClass('is-hide').addClass('is-show');
            $('#submit-step-1').prop('disabled', false);
        }

        if ($('input[name=land_features]:checked').val() === 'mono_parcel') {
            $('#form-item-network-presence').removeClass('is-hide').addClass('is-show');
            $('#form-item-desired-deadline').removeClass('is-hide').addClass('is-show');
            $('#form-item-land-accessibility').removeClass('is-hide').addClass('is-show');
            $('#form-item-network-presence').removeClass('is-hide').addClass('is-show');
            $('#submit-step-1').parent().removeClass('is-hide').addClass('is-show');
            $('#submit-step-1').prop('disabled', false);
        }

        // features
        $('body').on('change', 'input[name=land_features]', function (e) {
            var valFeatures = $('input[name=land_features]:checked').val();
            if (valFeatures === 'multi_parcel' || valFeatures === 'other') {
                //$('#form-item-desired-deadline').removeClass('is-show').addClass('is-hide');
                //$('#form-item-land-accessibility').removeClass('is-show').addClass('is-hide');
                // désactivation des autres champs
                blockForm('[name=land_features]', $('#form-alert-features'), "Pour une multi-parcelle et pour un terrain d'une surface supérieure à 2000 m², nous vous invitons à contacter votre agence, voir les coordonnées ci-contre ou cliquez sur le bouton ci-dessous.", true);
            } else {
                $('#form-item-desired-deadline').removeClass('is-hide').addClass('is-show');
                if ($('#desired_deadline').val() != '') {
                    $('#form-item-land-accessibility').removeClass('is-hide').addClass('is-show');
                }
                // activation des autres champs
                blockForm('[name=land_features]', $('#form-alert-features'), null, false);
            }
        });

        // deadline
        $('body').on('change', '#desired_deadline', function (e) {
            var valDeadline = $(this).val();
            if (valDeadline === 'deadline_3') {
                // désactivation des autres champs
                //$('#form-item-network-presence').addClass('is-hide');
                blockForm('#desired_deadline', $('#form-alert-deadline'), "Vous souhaitez que votre étude soit réalisée dans un délai inférieur à 4 semaines ? Nous vous invitons à contacter votre agence, voir les coordonnées ci-contre ou cliquez sur le bouton ci-dessous. Nous vous alertons à ce stade qu'un délai incompressible de 2 semaines sera néanmoins observé, du fait de la durée de procédure de DT/DICT. <a href=\"\\#FAQ-DT-DICT\" target='\"_blank\"'>En savoir plus</a>", true);
            } else {
                $('#form-item-land-accessibility').removeClass('is-hide').addClass('is-show');
                var valAccessibility = $('input[name=land_accessibility]:checked').val();
                if (valAccessibility === 'yes') {
                    $('#form-item-network-presence').removeClass('is-hide').addClass('is-show');
                }
                // activation des autres champs
                blockForm('#desired_deadline', $('#form-alert-deadline'), null, false);
            }
        });

        // accessibility
        $('body').on('change', 'input[name=land_accessibility]', function (e) {
            var valAccessibility = $('input[name=land_accessibility]:checked').val();
            if (valAccessibility === 'no') {
                // désactivation des autres champs
                //$('#form-item-network-presence').addClass('is-hide');
                blockForm('[name=land_accessibility]', $('#form-alert-accessibility'), "Votre terrain n'est pas accessible par de petits engins de chantier : des solutions existent; nous vous invitons à contacter votre agence, voir les coordonnées ci-contre ou cliquez sur le bouton ci-dessous.", true);
            } else {
                // activation des autres champs
                $('#form-item-network-presence').removeClass('is-hide').addClass('is-show');
                blockForm('[name=land_accessibility]', $('#form-alert-accessibility'), null, false);
            }
        });

        // network_presence
        $('body').on('change', 'input[name=network_presence]', function (e) {
            $('#submit-step-1').parent().removeClass('is-hide').addClass('is-show');
            $('#submit-step-1').prop('disabled', false);
        });

    }
    ///// étape 2
    //else if ($('.tunnel-wrapper.step2').length) {
    //}
    ///// étape 3
    //else if ($('.tunnel-wrapper.step3').length) {
    //}
    ///// étape 4
    else if ($('.tunnel-wrapper.step4').length) {
        $('.step4 #order').click(function(e) {
            e.preventDefault();

            $( ".form-errors" ).empty();
            $( "#dict_demand" ).removeClass( "is-on-error" );
            $( "#works_delay" ).removeClass( "is-on-error" );
            // $( "#rgpd" ).removeClass( "is-on-error" );
            // if(!$('#rgpd')[0].checked) {
            //     $( ".form-errors" ).append('<li class="rgpd">Le champ RGPD est requis.</li>');
            //     $( "#rgpd" ).addClass( "is-on-error" );
            //     $([document.documentElement, document.body]).animate({
            //         scrollTop: $(".form-errors").offset().top
            //     }, 500);
            // }

            if(!$('#dict_demand')[0].checked && !$('#works_delay')[0].checked) {
                $( ".form-errors" ).append('<li class="dict_demand">Le champ Demande de DICT conjointe est requis si vous ne cochez pas le champ Début des travaux</li>');
                $( ".form-errors" ).append('<li class="works_delay">Le champ Début des travaux est requis si vous ne cochez pas le champ Demande de DICT conjointe</li>');
                $( "#dict_demand" ).addClass( "is-on-error" );
                $( "#works_delay" ).addClass( "is-on-error" );
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".form-errors").offset().top
                }, 500);
            }

            if(($('#dict_demand')[0].checked || $('#works_delay')[0].checked)) {
                $.ajax({
                    url: '/ajax/order/paymentTry',
                    type: 'POST',
                    data: {'dict' : $('#dict_demand')[0].checked, 'retraction' : $('#works_delay')[0].checked},
                    dataType: 'json'
                }) .done(function (data) {
                    $('#bankcall form').submit();
                });
            }
        });
    }
    else if ($('.tunnel-wrapper.payment').length) {
        $('.payment #order').click(function(e) {
            e.preventDefault();

            $( ".form-errors" ).empty();
            $( "#dict_demand" ).removeClass( "is-on-error" );
            // $( "#rgpd" ).removeClass( "is-on-error" );

            // if(!$('#rgpd')[0].checked) {
            //     $( ".form-errors" ).append('<li class="rgpd">Le champ RGPD est requis.</li>');
            //     $( "#rgpd" ).addClass( "is-on-error" );
            //     $([document.documentElement, document.body]).animate({
            //         scrollTop: $(".form-errors").offset().top
            //     }, 500);
            // }

            if(!$('#dict_demand')[0].checked && !$('#works_delay')[0].checked) {
                $( ".form-errors" ).append('<li class="dict_demand">Le champ Demande de DICT conjointe est requis si vous ne cochez pas le champ Début des travaux</li>');
                $( ".form-errors" ).append('<li class="works_delay">Le champ Début des travaux est requis si vous ne cochez pas le champ Demande de DICT conjointe</li>');
                $( "#dict_demand" ).addClass( "is-on-error" );
                $( "#works_delay" ).addClass( "is-on-error" );
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".form-errors").offset().top
                }, 500);
            }

            if(($('#dict_demand')[0].checked || $('#works_delay')[0].checked)) {
                var formData = new FormData($('#payment-form')[0]);
                $.ajax({
                    url: '/ajax/order/paymentConfirm',
                    type: 'POST',
                    data: formData,
                    dataType: 'json',
                    contentType: false,
                    processData: false,
                }) .done(function (data) {
                    if(typeof data['file_errors'] === 'undefined') {
                        $.ajax({
                            url: '/ajax/order/paymentTry',
                            type: 'POST',
                            data: {'dict' : $('#dict_demand')[0].checked, 'retraction' : $('#works_delay')[0].checked},
                            dataType: 'json'
                        }) .done(function (data) {
                            $('#bankcall form').submit();
                        });
                    } else {
                        $( ".form-errors" ).empty();
                        $.each(data.file_errors, function(i, val) {
                            $( ".form-errors" ).append('<li class="' + i + '">'+ val + '</li>');
                            $( "#" + i ).addClass( "is-on-error" );
                        });
                    }
                });
            }
        });
    }
}

/**
 * Format Fields Errors
 */
function formatFieldsErrors() {
    $('.form-errors > li').each(function () {
        var formItem = '[name=' + $(this).attr('class') + ']';

        if ($(formItem).length) {
            $(formItem).addClass('is-on-error');
        }
    });

}

/**
 * Refresh Push Contact
 */
function refreshPushContact() {
    if ($(window).outerWidth() >= breakpoint_tablethor) {
        let pushWrapperTop = $('.push-wrapper').offset().top;
        let footerTop = $('.page--footer').offset().top;
        let pushImageHeight = $('.push-wrapper .push-contact--image').outerHeight();
        let pushContentHeight = $('.push-wrapper .push-contact--content').outerHeight();

        if ($(window).scrollTop() >= pushWrapperTop + pushImageHeight &&
            $(window).scrollTop() + pushContentHeight < footerTop - 30 &&
            $('.tunnel-content').outerHeight() > $('.push-wrapper').outerHeight()) {
            $('.push-contact').addClass('sticky');
        } else {
            $('.push-contact').removeClass('sticky');
        }
    } else {
        $('.push-contact').removeClass('sticky');
    }
}

/**
 * Validate zipcode
 */
function validateZipcode(objZipcode) {
    var displayError = false;

    // désactivation push contact
    $('.push-contact').addClass('hidden');
    $('#step1-more-informations').removeClass('is-show').addClass('is-hide');

    if (objZipcode.val().length === 5 && !isNaN(objZipcode.val())) {
        $.ajax({
            url: '/ajax/order/checkZipcode',
            type: 'POST',
            data: {'zipcode': objZipcode.val()},
            dataType: 'json'
        })
            .done(function (data) {
                if (data.agency) {
                    $('.push-contact .contact-name').text(data.agency.infos['Nom']);
                    $('.push-contact .contact-address').text(data.agency.infos['Adresse']);
                    $('.push-contact .contact-zipcode').text(data.agency.infos['Code postal']);
                    $('.push-contact .contact-city').text(data.agency.infos['Ville']);

                    $('.push-contact .contact-phone').text(data.agency.infos['tel']);
                    $('.push-contact .contact-phone').attr('href', 'tel:+33' + data.agency.infos['tel']);
                    if (data.agency.infos['tel'] !== null) {
                        $('.push-contact .contact-phone').show();
                    } else {
                        $('.push-contact .contact-phone').hide();
                    }

                    $('.push-contact .contact-email').text(data.agency.infos['mail']);
                    $('.push-contact .contact-email').attr('href', 'mailto:' + data.agency.infos['mail']);
                    if (data.agency.infos['mail'] !== null) {
                        $('.push-contact .contact-email').show();
                    } else {
                        $('.push-contact .contact-email').hide();
                    }

                    $('.push-contact.hidden').removeClass('hidden');

                    if (data.agency.availability) {
                        $('#step1-more-informations').removeClass('is-hide').addClass('is-show');
                    } else {
                        $('#step1-more-informations').removeClass('is-show').addClass('is-hide');

                        // désactivation des autres champs
                        blockForm('#zipcode', $('#form-alert-zipcode'), "Pour obtenir des informations ou un devis, nous vous invitons à contacter votre agence, voir les coordonnées ci-contre ou cliquez sur le bouton ci-dessous.", true);
                        displayError = true;
                    }
                }
                else {
                    $('#step1-more-informations').removeClass('is-show').addClass('is-hide');

                    // désactivation des autres champs
                    blockForm('#zipcode', $('#form-alert-zipcode'), "Pour obtenir des informations ou un devis, nous vous invitons à contacter votre agence en cliquant sur le bouton ci-dessous.", true);
                    displayError = true;
                }
            });
    }

    if (!displayError) {
        // activation des autres champs
        blockForm('#zipcode', $('#form-alert-zipcode'), null, false);
    }
}

/**
 * Block form
 */
function blockForm(objField, objMsg, msg, displayBtnContact) {
    if (msg != null) {
        objMsg.html(msg).removeClass('is-empty');
        $('.tunnel-content')
            .find('.btn:not("#contact"), .form-text, .form-number, .form-email, .form-textarea, .form-select, .form-radio, .form-checkbox')
            .not(objField)
            .prop('disabled', true);
        if (displayBtnContact) {
            objMsg.append($('.group-btn-contact').clone().removeClass('is-hide').addClass('is-show'));
            objMsg.find('.btn').prop('id', 'btn-contact').on('click', function (e) {
                // réactivation des champs de formulaires pour pouvoir les envoyer
                $('.tunnel-content')
                    .find('.btn:not("#contact"), .form-text, .form-number, .form-email, .form-textarea, .form-select, .form-radio, .form-checkbox')
                    .prop('disabled', false);
            });
        }
    } else {
        objMsg.addClass('is-empty').html("");
        $('.tunnel-content')
            .find('.btn:not("#contact"), .form-text, .form-number, .form-email, .form-textarea, .form-select, .form-radio, .form-checkbox')
            .not(objField)
            .prop('disabled', false);
    }
}

function initAnchors() {
    let strHref = document.location.href;
    if (strHref.indexOf('#') > 0) {
        let idAnchor = strHref.split('#')[1];
        scrollToAnchor(idAnchor);
    }

    /*$('body').on('click touch', 'dt', function (e) {
        let strHref = $(this).find('a').attr('href');*/
    $('body').on('click touch', 'dt, dd a', function (e) {
        let objLink = $(this);
        if ($(this).find('a').length) {
            objLink = $(this).find('a').eq(0);
        }

        let strHref = objLink.attr('href');

        if (strHref.length && strHref.length > 1 && strHref.substring(0, 1) == '#' && $(strHref).length) {
            e.preventDefault();

            // ancres FAQ
            let elFaq = $(this).closest('.block-faq');
            if (elFaq.length) {
                let elDt = $(this).closest('dt');

                // ancres question
                if (elDt.length) {
                    elDt.addClass('selected');
                    elFaq.find('dt:not(.selected)').removeClass('active');
                    elDt.removeClass('selected').toggleClass('active');
                }
                // ancres présentes dans réponse
                else if ($(this).closest('dd') && $($(this).attr('href'))) {
                    let elDt = $($(this).attr('href')).prev('dt');

                    elDt.addClass('selected');
                    elFaq.find('dt:not(.selected)').removeClass('active');
                    elDt.removeClass('selected').addClass('active');

                    var topAnchor = elDt.offset().top;
                    $('html, body').stop().animate({scrollTop: topAnchor}, 400);
                }
            }

            // autres ancres
            else {
                var topAnchor = $($(this).attr('href')).offset().top;
                $('html, body').stop().animate({scrollTop: topAnchor}, 400);
            }
        }
    });
}

function scrollToAnchor(idAnchor) {
    if ($('#' + idAnchor).length) {
        let objTarget = $('#' + idAnchor);
        // ancres FAQ
        let elFaq = objTarget.closest('.block-faq');

        if (elFaq.length) {
            if (objTarget[0].tagName == 'DT') {
                objTarget.addClass('selected');
                elFaq.find('dt:not(.selected)').removeClass('active');
                objTarget.removeClass('selected').toggleClass('active');

                var topAnchor = objTarget.offset().top;
                $('html, body').stop().animate({scrollTop: topAnchor}, 400);
            }
            else if (objTarget[0].tagName == 'DD') {
                let elDt = $(objTarget).prev('dt');

                elDt.addClass('selected');
                elFaq.find('dt:not(.selected)').removeClass('active');
                elDt.removeClass('selected').toggleClass('active');

                var topAnchor = elDt.offset().top;
                $('html, body').stop().animate({scrollTop: topAnchor}, 400);
            }
        }
        // autres ancres
        else {
            var topAnchor = objTarget.offset().top;
            $('html, body').stop().animate({scrollTop: topAnchor}, 400);
        }
    }
}
